module.exports = __webpack_public_path__ + "static/header-bg-eee425c02c02639cf974091b81c7f53c.png";